import IncomeToRentRatioSection from './IncomeToRentRatioSection';

export default IncomeToRentRatioSection;
